import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "@/components/landing/Logo";

const Ctx = createContext(() => {});

export const AuthPromptProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  return (
    <Ctx.Provider value={() => setOpen(true)}>
      {children}
      {open && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 px-4 backdrop-blur-sm"
          onClick={() => setOpen(false)}
          data-testid="auth-prompt-modal"
        >
          <div
            className="w-full max-w-sm rounded-3xl border border-white/10 bg-surface p-8 text-center"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-center">
              <Logo size={52} />
            </div>
            <h2 className="mt-4 font-heading text-xl font-bold text-white">Sign in to do that</h2>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">
              Liking, commenting, sharing, messaging, following and uploading need a free Michael C
              Streamline account — the same one you use in the phone app.
            </p>
            <button
              onClick={() => go("/app/login")}
              data-testid="auth-prompt-signin"
              className="mt-6 w-full rounded-full bg-crimson py-3 font-heading text-sm font-bold text-white transition-colors hover:bg-crimson-hover"
            >
              Sign in
            </button>
            <button
              onClick={() => go("/app/login?mode=register")}
              data-testid="auth-prompt-register"
              className="mt-2 w-full rounded-full border border-white/15 py-3 font-heading text-sm font-bold text-slate-200 transition-colors hover:border-crimson/50"
            >
              Create account
            </button>
            <button onClick={() => setOpen(false)} className="mt-4 text-xs text-slate-500 transition-colors hover:text-white" data-testid="auth-prompt-dismiss">
              Not now
            </button>
          </div>
        </div>
      )}
    </Ctx.Provider>
  );
};

export const useAuthPrompt = () => useContext(Ctx);
